import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Data, Router } from '@angular/router';
import { DialogService } from '../../../../services/dialog.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Utils } from '../../../../utils/utils';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import moment from 'moment';
import { DatePipe } from '@angular/common'
import { CustomerIdsListComponent } from '../customeridslist/customeridslist.component';

@Component({
    selector: 'azdatafactoryform',
    templateUrl: './azdatafactoryform.component.html',
    styleUrls: ['../../../../style/azdatafactory.component.less', '../../../../style/custom-mat-dialog.component.less'],
    standalone: false
})
export class AzDataFactoryFormComponent implements OnInit {
    body: any;
    type: string = '';
    item: string = '';
    targetSystemList: string[] = [];
    minDate = new Date();
    form!: FormGroup;
    submitted = false;

    constructor(
        private http: HttpClient,
        private confimDialog: DialogService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject('BASE_URL') private baseUrl: string,
        public dialogRef: MatDialogRef<AzDataFactoryFormComponent>,
        private fb: FormBuilder,
        private defaults: DefaultValuesService,
        private formBuilder: FormBuilder,
        private datepipe: DatePipe,
        private dialogForm: MatDialog
    ) {
        this.confimDialog.tthis = this;
        this.minDate.setDate(this.minDate.getDate() - 7);
    }

    ngOnInit(): void {
        const currentDate = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));
        this.initializeForm(currentDate);
    }

    get f() {
        return this.form.controls;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        this.submitted = true;
        if (this.form.invalid) {
            return;
        }
        this.handleFormSubmission();
    }

    onBack() {
        // Implement back functionality if needed
    }

    private initializeForm(currentDate: Date): void {
        this.initializeOtherForms(currentDate);
    }

    private initializeOtherForms(currentDate: Date): void {
        switch (this.data.type) {
            case 'Elevator':
            case 'Escalator':
                this.initializeMasterDataForm(currentDate, true);
                break;
            case 'OtherAsset':
                this.initializeMasterDataForm(currentDate, false);
                break;
            case 'Customer':
            case 'Contract':
            case 'CustomerFacilityManager':
            case 'ContractFacilityManager':
            case 'Kpi':
            case 'CustomerDocument':
            case 'Contact':
            case 'ContactToUnit':
            case 'Inspection':
                this.initializeInfoHubForm(currentDate);
                break;
            case 'ServiceTicket':
                this.initializeServiceTicketForm(currentDate);
                break;
        }
    }

    private initializeMasterDataForm(currentDate: Date, includeWindowEnd: boolean): void {
        Utils.httpGetTargetSystemByTenant(
            this.http,
            this.baseUrl,
            this.defaults.stage,
            this.defaults.tenant,
            this,
            (tthis: AzDataFactoryFormComponent, list: string[]) => {
                tthis.targetSystemList = list;
            }
        );
        this.body = {
            TargetSystem: 'Default',
            WindowStart: currentDate,
            ...(includeWindowEnd && { WindowEnd: currentDate }),
            SessionId: ''
        };
        this.type = 'MasterData';
        this.item = this.data.type;
        this.form = this.formBuilder.group({
            targetSystem: ['', [Validators.required]],
            windowStart: [this.dateValidator],
            ...(includeWindowEnd && { windowEnd: [this.dateValidator] }),
            sessionId: ['', this.sessionIdValidator]
        });
    }

    private initializeInfoHubForm(currentDate: Date): void {
        this.body = {
            SelectionDateFrom: currentDate,
            PagingCount: 5000,
            CustomerIds: ''
        };
        this.type = 'InfoHub';
        this.item = this.data.type;
        this.form = this.formBuilder.group({
            selectionDateFrom: [this.dateValidator],
            pagingCount: [5000, [Validators.min(1), Validators.required]],
            customerIds: ['']
        });
    }

    private initializeServiceTicketForm(currentDate: Date): void {
        this.body = {
            StartDateTime: null,
            EndDateTime: null,
            SelectionDateFrom: currentDate,
            PagingCount: 5000,
            CustomerIds: ''
        };
        this.type = 'InfoHub';
        this.item = this.data.type;
        this.form = this.formBuilder.group({
            startDateTime: [this.dateValidator],
            endDateTime: [this.dateValidator],
            selectionDateFrom: [this.dateValidator],
            pagingCount: [5000, [Validators.min(1), Validators.required]],
            customerIds: ['']
        });
    }

    private handleFormSubmission(): void {
        if (this.isMasterDataType() && this.body.TargetSystem === 'Default') {
            this.body.TargetSystem = null;
        }

        if (this.isInfohubEntity() && this.body.CustomerIds !== '') {
            this.openCustomerIdDialog();
        } else {
            this.executePostTriggerAzdf();
        }
    }

    private isMasterDataType(): boolean {
        return ['Elevator', 'Escalator', 'OtherAsset'].includes(this.data.type);
    }

    private openCustomerIdDialog(): void {
        const customerIdDialog = this.dialogForm.open(CustomerIdsListComponent, {
            panelClass: 'custom-mat-dialog',
            data: { "customerids": this.body.CustomerIds }
        });
        customerIdDialog.afterClosed().subscribe(result => {
            if (Boolean(result.result) === true) {
                this.executePostTriggerAzdf();
            }
        });
    }

    private executePostTriggerAzdf(): void {
        Utils.httpPostTriggerAzdf(
            this.http,
            this.baseUrl,
            this.body,
            this.type,
            this.item,
            this,
            (tthis: AzDataFactoryFormComponent, object: AzDataFactoryRun, type: string, item: string) => {
                tthis.dialogRef.close({ event: 'submit' });
                if (object.RunId === '00000000-0000-0000-0000-000000000000') {
                    tthis.confimDialog.showErrorDialog({
                        'error': {
                            'message': `${type} - ${item} Trigger cannot be executed. Due to security policies, it is needed to wait until ${tthis.datepipe.transform(object.StartDate, 'yyyy-MM-dd HH:mm', '+000')} UTC`
                        }
                    });
                } else {
                    tthis.confimDialog.showSuccessDialog(`${type} - ${item} Trigger has been executed successfully with RunId - ${object.RunId}`);
                }
            },
            (tthis: AzDataFactoryFormComponent, error: any) => {
                tthis.dialogRef.close({ event: 'error' });
                if (error.status === 400 && error.error?.code === 'DATAFACTORY_NOT_CONFIGURED') {
                    tthis.confimDialog.showErrorStringDialog(error.error.message);
                } else {
                    tthis.confimDialog.showErrorDialog(error);
                }
            }
        );
    }

    dateValidator(control: FormControl): { [s: string]: boolean } {
        if (control.value) {
            const date = moment(control.value);
            return date.isValid() ? { 'invalidDate': false } : { 'invalidDate': true };
        }
        return { 'invalidDate': false };
    }

    sessionIdValidator(control: FormControl): { [s: string]: boolean } {
        if (("" + control.value) === '') return {};
        const reEmail = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return control.value ? { 'invalid': !reEmail.test("" + control.value) } : { 'invalid': true };
    }

    isInfohubEntity(): boolean {
        const infoHubEntities = [
            'Customer', 'CustomerFacilityManager', 'Contract', 'ContractFacilityManager',
            'ServiceTicket', 'Kpi', 'CustomerDocument', 'Inspection', 'Contact', 'ContactToUnit'
        ];
        return infoHubEntities.includes(this.item);
    }

    isCustomerRelatedEntity(): boolean {
        const customerRelatedEntities = [
            'Customer', 'CustomerFacilityManager', 'Contract', 'ContractFacilityManager',
            'ServiceTicket', 'Kpi', 'CustomerDocument', 'Inspection', 'ContactToUnit'
        ];
        return customerRelatedEntities.includes(this.item);
    }
}
